import {
  dateFormat,
  formatDateAndTime,
} from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'react-qr-code';
import React from 'react';

const generateQRCodeSVG = value => {
  const qrCodeElement = (
    <QRCode
      size={128}
      style={{ height: '75px', width: '75px' }}
      value={value}
      // viewBox={`0 0 128 128`}
    />
  );
  return renderToStaticMarkup(qrCodeElement);
};

export const ELetterServiceClient = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getCustomer,
  paramVal,
  ItemIndex,
}) => {
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
  const contact = Array.isArray(previewDetail?.contract?.contact)
    ? previewDetail?.contract?.contact[0]
    : previewDetail?.contract?.contact;

  const bankAddress =
    previewDetail?.contract?.bankAccount?.bankProfile?.address;

  const debtorDetails = {
    // ==========================
    // COMPANY / CLIENT DETAILS
    // ==========================
    '[clientName]': previewDetail?.customer?.name ?? '',
    '[clientEmail]': previewDetail?.customer?.email ?? '',
    '[clientContactNo]':
      previewDetail?.contact?.contactNo ??
      previewDetail?.contract?.contact?.[0]?.contactNo ??
      previewDetail?.customer?.contactPerson?.[0]?.contactNo ??
      '',
    '[contactPerson]':
      previewDetail?.contact?.name ??
      previewDetail?.contract?.contact?.[0]?.name ??
      previewDetail?.customer?.contactPerson?.[0]?.name ??
      '',

    // ==========================
    // CLIENT ADDRESS
    // ==========================
    '[clientAddress]': `${previewDetail?.customer?.address?.address}<br />
    ${
      previewDetail?.customer?.address?.country === 'Singapore'
        ? `${previewDetail?.customer?.address?.country} ${previewDetail?.customer?.address?.postCode}`
        : `${previewDetail?.customer?.address?.postCode} ${previewDetail?.customer?.address?.city}, 
          ${previewDetail?.customer?.address?.state}, ${previewDetail?.customer?.address?.country}`
    }<br />`,

    // ==========================
    // CLIENT BANK DETAILS
    // ==========================
    '[clientBankAccName]': previewDetail?.customer?.BankName ?? '',
    '[clientBankAccNo]': previewDetail?.customer?.BankAccountNo ?? '',

    // ==========================
    // CLIENT REGISTRATION NUMBERS
    // ==========================
    '[clientCompanyRegNo]': previewDetail?.customer?.registrationNo ?? '',
    '[clientTIN]': previewDetail?.customer?.tinNo ?? '',
    '[clientRegNo]':
      previewDetail?.customer?.gstRegNo ??
      previewDetail?.customer?.registrationNo ??
      '',
    '[clientSstNo]': previewDetail?.customer?.sstRegNo ?? '',
    '[companySSTRegNo]': previewDetail?.SSTRegNo ?? '',

    // ==========================
    // DOCUMENT DETAILS
    // ==========================
    '[docNo]': previewDetail?.docNo ?? '',
    '[docRef]': previewDetail?.docRef ?? '',
    '[docDate]': dateFormat(previewDetail?.docDate) ?? '',
    '[description]': previewDetail?.description ?? '',

    // ==========================
    // CONTRACT DETAILS
    // ==========================
    '[contractTitle]':
      previewDetail?.contract?.pdfDocumentTitle ??
      previewDetail?.contract?.title ??
      '',
    '[creditTerm]': previewDetail?.contract?.creditTerm ?? 0,
    '[contractDate]': previewDetail?.contract?.contractDate ?? '',

    // ==========================
    // BANK DETAILS
    // ==========================
    '[bankName]': previewDetail?.contract?.bankAccount?.bankProfile?.name ?? '',
    '[bankAddress]': `${bankAddress?.address}, ${bankAddress?.city}, 
          ${bankAddress?.state}, ${bankAddress?.country}, ${bankAddress?.postCode}`,
    '[bankAccountNo]': previewDetail?.contract?.bankAccount?.accountNo ?? '',
    '[bankSwiftCode]': previewDetail?.contract?.bankAccount?.swiftCode ?? '',

    // ==========================
    // E-INVOICE PARAMETERS
    // ==========================
    '[qrCode]':
      previewDetail?.isEInvoice && previewDetail?.eInvoiceQrUrl
        ? generateQRCodeSVG(previewDetail?.eInvoiceQrUrl)
        : '',
    '[EInvoiceValidatedDate]': previewDetail?.einvoice_validation_date
      ? formatDateAndTime(previewDetail?.einvoice_validation_date)
      : '',
    '[EInvoiceSentDate]': previewDetail?.einvoice_sent_date
      ? formatDateAndTime(previewDetail?.einvoice_sent_date)
      : '',
    '[EInvoiceStatus]': previewDetail?.einvoice_status ?? '',
    '[uniqueIdentifierNo]': previewDetail?.eInvoiceIrbmUniqueID ?? '',
  };

  /* -------------------------------------------------
   * 1 and 2.  ADVANCES & OFFICIAL RECEIPT
   * -------------------------------------------------*/
  switch (docType) {
    case 'advances':
    case 'official-receipt': {
      Object.assign(paramVal, debtorDetails, {
        // ==========================
        // DOCUMENT DESCRIPTION
        // ==========================
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ==========================
        // BANK & PAYMENT DETAILS
        // ==========================
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ==========================
        // AMOUNT DETAILS
        // ==========================
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[itemTotalAmt]': amtStr(previewDetail?.docAmt) ?? '',

        // ==========================
        // CURRENCY DETAILS
        // ==========================
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
      });
      break;
    }

    /* -------------------------------------------------
     * 3.  REFUND DOCUMENT
     * -------------------------------------------------*/
    case 'refund': {
      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * BASIC INFO
         * ────────────────*/
        '[remark]': previewDetail?.remark ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        /* ────────────────
         * BANK / PAYMENT
         * ────────────────*/
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        /* ────────────────
         * ALLOCATION ITEMS (TABLE)
         * ────────────────*/
        items: (previewDetail?.allocation ?? []).map(el => ({
          '[allocationDate]': dateFormat(el?.docDate) ?? '',
          '[allocationNo]': el?.docNo ?? '',
          '[allocationDesc]': el?.description ?? '',
          '[allocationAmt]': amtStr(el?.allocatedByDoc ?? 0),
        })),

        /* ────────────────
         * AMOUNTS
         * ────────────────*/
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[itemTotalAmt]': amtStr(previewDetail?.docAmt) ?? '',

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
      });
      break;
    }

    /* -------------------------------------------------
     * 4.  MISCELLANEOUS INVOICE
     * -------------------------------------------------*/
    case 'misc-invoice': {
      /* Helper calculations */
      const totalPrincipalAmt =
        previewDetail?.contractMiscInvoiceItem?.reduce(
          (sum, item) =>
            sum + (Number(item?.docAmt) - Number(item?.taxAmt || 0)),
          0,
        ) ?? 0;

      const totalTaxAmt =
        previewDetail?.contractMiscInvoiceItem?.reduce(
          (sum, item) => sum + Number(item?.taxAmt || 0),
          0,
        ) ?? 0;

      const docAmt = totalPrincipalAmt + totalTaxAmt; // grand total
      const totalAmtInWords = moneyFunction(docAmt);

      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * BENEFICIARY
         * ────────────────*/
        '[beneficiaryNo]':
          previewDetail?.contract?.bankAccount?.accountNo ?? '',
        '[beneficiaryBankName]':
          previewDetail?.contract?.bankAccount?.name ?? '',

        /* ────────────────
         * CONTACT
         * ────────────────*/
        '[invoiceContractTitle]': previewDetail?.contract?.title ?? '',
        '[invoiceContactNo]':
          previewDetail?.customer?.contactPerson?.[0]?.contactNo ?? '',
        '[invoiceContactName]':
          previewDetail?.customer?.contactPerson?.[0]?.name ?? '',

        /* ────────────────
         * LINE‑ITEMS
         * ────────────────*/
        items: (previewDetail?.contractMiscInvoiceItem ?? []).map(item => {
          const principal = Number(item?.docAmt) - Number(item?.taxAmt || 0);
          const rate = Number(item?.taxRate || 0);
          const tax = principal * (rate / 100);
          const total = principal + tax;

          return {
            '[itemDescription]': item?.revenueCategory?.name ?? '',
            '[classification]':
              item?.classificationCode?.classificationCode ?? '',
            '[principalAmt]': amtStr(principal),
            '[taxRate]': `${amtStr(rate)}%`,
            '[itemTaxAmt]': amtStr(tax),
            '[itemPrincipalAmt]': amtStr(total),
          };
        }),

        /* ────────────────
         * TOTALS
         * ────────────────*/
        '[totalPrincipalAmt]': amtStr(totalPrincipalAmt.toFixed(2)),
        '[totalTaxAmt]': amtStr(totalTaxAmt.toFixed(2)),
        '[docAmt]': amtStr(docAmt.toFixed(2)),

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': totalAmtInWords,
      });
      break;
    }

    /* -------------------------------------------------
     * 5. CREDIT NOTE
     * -------------------------------------------------*/
    case 'credit-note': {
      const principalTotal =
        previewDetail?.contractCNItem?.reduce(
          (sum, item) =>
            sum + (Number(item?.docAmt) - Number(item?.taxAmt || 0)),
          0,
        ) ?? 0;

      const taxTotal =
        previewDetail?.contractCNItem?.reduce(
          (sum, item) => sum + Number(item?.taxAmt || 0),
          0,
        ) ?? 0;

      const total = principalTotal + taxTotal;

      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * LINE ITEMS
         * ────────────────*/
        items: (previewDetail?.contractCNItem ?? []).map(item => {
          const principal = Number(item?.docAmt) - Number(item?.taxAmt || 0);
          const rate = Number(item?.taxRate || 0);
          const tax = principal * (rate / 100);
          const totalItem = principal + tax;

          return {
            '[itemDescription]': item?.revenueCategory?.name ?? '',
            '[classification]':
              item?.classificationCode?.classificationCode ?? '',
            '[principalAmt]': amtStr(principal),
            '[taxRate]': `${amtStr(rate)}%`,
            '[itemTaxAmt]': amtStr(tax),
            '[itemPrincipalAmt]': amtStr(totalItem),
          };
        }),

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',

        /* ────────────────
         * TOTALS
         * ────────────────*/
        '[totalAmtInWords]': moneyFunction(total),
        '[totalPrincipalAmt]': amtStr(principalTotal.toFixed(2)),
        '[totalTaxAmt]': amtStr(taxTotal.toFixed(2)),
        '[docAmt]': amtStr(total.toFixed(2)),
      });

      break;
    }

    /* -------------------------------------------------
     * 6. DEBIT NOTE
     * -------------------------------------------------*/
    case 'debit-note': {
      const principalTotal =
        previewDetail?.contractDNItem?.reduce(
          (sum, item) =>
            sum + (Number(item?.docAmt) - Number(item?.taxAmt || 0)),
          0,
        ) ?? 0;

      const taxTotal =
        previewDetail?.contractDNItem?.reduce(
          (sum, item) => sum + Number(item?.taxAmt || 0),
          0,
        ) ?? 0;

      const total = principalTotal + taxTotal;

      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * LINE ITEMS
         * ────────────────*/
        items: (previewDetail?.contractDNItem ?? []).map(item => {
          const principal = Number(item?.docAmt) - Number(item?.taxAmt || 0);
          const rate = Number(item?.taxRate || 0);
          const tax = principal * (rate / 100);
          const totalItem = principal + tax;

          return {
            '[itemDescription]': item?.revenueCategory?.name ?? '',
            '[classification]':
              item?.classificationCode?.classificationCode ?? '',
            '[principalAmt]': amtStr(principal),
            '[taxRate]': `${amtStr(rate)}%`,
            '[itemTaxAmt]': amtStr(tax),
            '[itemPrincipalAmt]': amtStr(totalItem),
          };
        }),

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',

        /* ────────────────
         * TOTALS
         * ────────────────*/
        '[totalAmtInWords]': moneyFunction(total),
        '[totalPrincipalAmt]': amtStr(principalTotal.toFixed(2)),
        '[totalTaxAmt]': amtStr(taxTotal.toFixed(2)),
        '[docAmt]': amtStr(total.toFixed(2)),
      });

      break;
    }

    /* -------------------------------------------------
     * 7. RETENTION CLAIMS
     * -------------------------------------------------*/
    case 'retention-claims': {
      Object.assign(paramVal, debtorDetails, {
        // ───── BASIC DETAILS ─────
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ───── BANK / PAYMENT ─────
        '[beneficiaryNo]':
          previewDetail?.contract?.bankAccount?.accountNo ?? '',
        '[beneficiaryBankName]':
          previewDetail?.contract?.bankAccount?.name ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ───── AMOUNTS ─────
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[itemTotalAmt]': amtStr(previewDetail?.docAmt) ?? '',

        // ───── CURRENCY ─────
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
      });
      break;
    }

    /* -------------------------------------------------
     * 8. CLAIM SUMMARY
     * -------------------------------------------------*/
    case 'claim-summary': {
      const submittedCurrentCertifiedAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentCertifiedAmt
          : previewDetail?.submittedCertifiedAmt || '0',
      );
      const submittedcurrentVOClaimAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.submittedVOClaimAmt
          : previewDetail?.currentVOClaimAmt || '0',
      );
      const submittedCurrentMosAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentMosAmt
          : previewDetail?.submittedMosAmt || '0',
      );
      const retentionAmt = parseFloat(previewDetail?.retentionAmt || '0');
      const previousCertifiedAmt = parseFloat(
        previewDetail?.previousCertifiedAmt || '0',
      );
      const currentDayWorkAmt = parseFloat(
        previewDetail?.currentDayWorkAmt || '0',
      );
      const taxAmt = parseFloat(previewDetail?.taxAmt || '0');

      const totalAmountDue =
        submittedCurrentCertifiedAmt +
        submittedcurrentVOClaimAmt +
        submittedCurrentMosAmt -
        retentionAmt -
        previousCertifiedAmt +
        currentDayWorkAmt;
      const itemTotalAmt = totalAmountDue + taxAmt;

      Object.assign(paramVal, debtorDetails, {
        // ───── BASIC DETAILS ─────
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ───── BANK / PAYMENT ─────
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ───── AMOUNTS ─────
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',

        '[totalAmountDue]': amtStr(totalAmountDue.toString()) ?? '',
        '[itemTotalAmt]': amtStr(itemTotalAmt.toString()) ?? '',
        '[totalAmtInWords]': moneyFunction(itemTotalAmt.toString()),

        // ───── CONTRACT INFO ─────
        '[contractNo]': previewDetail?.contract?.contractNo ?? '',
        '[contractSum]': amtStr(previewDetail?.contract?.contractSum),
        '[voAmount]': amtStr(previewDetail?.voDisplayAmt),
        '[revisedContractSum]': amtStr(
          previewDetail?.contract?.revisedContractSum,
        ),
        '[maxRetentionSum]': amtStr(previewDetail?.contract?.maxRetentionSum),

        // ───── DATES ─────
        '[docDate]': dateFormat(previewDetail?.contract?.startDate),
        '[docDueDate]': dateFormat(previewDetail?.contract?.endDate),
        '[submissionDate]': dateFormat(previewDetail?.submittedDate),
        '[approvalDate]': dateFormat(previewDetail?.docDate),

        // ───── REFERENCE DETAILS ─────
        '[docRefNo]': previewDetail?.docRef ?? '',
        '[docNo]': previewDetail?.docNo ?? '',
        '[claimNo]': previewDetail?.claimDocNo ?? '',
        '[clientContact]':
          previewDetail?.customer?.contactPerson[0]?.contactNo ?? '',

        // ───── CLAIM COMPONENTS ─────
        '[currentApprovalAmt]': amtStr(
          previewDetail?.transactionStatus === 'APPROVED'
            ? previewDetail?.currentCertifiedAmt
            : previewDetail?.submittedCertifiedAmt,
        ),
        '[voClaimAmt]': amtStr(
          previewDetail?.transactionStatus === 'APPROVED'
            ? previewDetail?.submittedVOClaimAmt
            : previewDetail?.currentVOClaimAmt,
        ),
        '[totalClaimApprovalAmt]':
          amtStr(
            (
              submittedCurrentCertifiedAmt + submittedcurrentVOClaimAmt
            ).toString(),
          ) ?? '',

        '[currentMosAmt]': amtStr(previewDetail?.submittedMosAmt),
        '[previousMosAmt]': amtStr(previewDetail?.previousMosAmt),
        '[submittedMosAmt]': amtStr(previewDetail?.submittedMosAmt),

        '[retentionAmt]': amtStr(previewDetail?.retentionAmt),
        '[previousCertifiedAmt]': amtStr(previewDetail?.previousCertifiedAmt),
        '[previousVOClaimAmt]': amtStr(previewDetail?.previousVOClaimAmt),

        '[dayworksAmt]': amtStr(previewDetail?.currentDayWorkAmt),
        '[subtotalAmt]':
          amtStr(
            (
              submittedCurrentCertifiedAmt +
              submittedcurrentVOClaimAmt +
              submittedCurrentMosAmt -
              retentionAmt
            ).toString(),
          ) ?? '',
        '[currentDeductionAmt]': amtStr(previewDetail?.currentDeductionAmt),
        '[advanceRecoupmentAmt]': amtStr(previewDetail?.advanceRecoupmentAmt),

        // ───── NOTES ─────
        '[noteText]': previewDetail?.noteText ?? '',

        // ───── CURRENCY ─────
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
      });
      break;
    }

    case 'claim-invoice': {
      const certifiedAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentCertifiedAmt
          : previewDetail?.submittedCertifiedAmt || '0',
      );
      const submittedVOAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentVOClaimAmt
          : previewDetail?.submittedVOClaimAmt || '0',
      );
      const previousCertifiedAmt = parseFloat(
        previewDetail?.previousCertifiedAmt || '0',
      );
      const previousVOAmt = parseFloat(
        previewDetail?.previousVOClaimAmt || '0',
      );
      const previousMosAmt = parseFloat(previewDetail?.previousMosAmt || '0');
      const submittedMosAmt = parseFloat(previewDetail?.submittedMosAmt || '0');
      const submittedDayworkAmt = parseFloat(
        previewDetail?.submittedDayWorkAmt || '0',
      );
      const retentionAmt = parseFloat(previewDetail?.retentionAmt || '0');

      const taxAmt = parseFloat(previewDetail?.taxAmt || '0');

      const totalClaimAmt =
        certifiedAmt +
        submittedVOAmt -
        previousCertifiedAmt +
        submittedMosAmt +
        submittedDayworkAmt;
      const totalPayableAmt = totalClaimAmt - retentionAmt;
      const progressBillingToDate =
        certifiedAmt + submittedVOAmt - previousCertifiedAmt;

      const totalBaseAmt =
        certifiedAmt +
        submittedVOAmt +
        submittedMosAmt -
        previousCertifiedAmt -
        previousVOAmt -
        previousMosAmt -
        retentionAmt;

      const itemTotalAmt = totalBaseAmt + taxAmt;
      const sumOfClaim = itemTotalAmt + retentionAmt;

      Object.assign(paramVal, debtorDetails, {
        // ───── BASIC ─────
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ───── PAYMENT ─────
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ───── AMOUNTS ─────
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[progressBillingToDate]': amtStr(progressBillingToDate.toString()),
        '[totalAmtInWords]': moneyFunction(totalPayableAmt.toString()),

        '[totalClaimAmt]': amtStr(sumOfClaim),
        '[totalPayableAmt]': amtStr(totalPayableAmt.toString()),

        '[subtotalAmt]': amtStr(previewDetail?.baseAmt),
        '[retentionReceivable]': amtStr(previewDetail?.retentionAmt),
        '[itemTaxAmt]': amtStr(taxAmt),
        '[itemTotalAmt]': amtStr(itemTotalAmt),

        // ───── CONTRACT INFO ─────
        '[contractNo]': previewDetail?.contract?.contractNo ?? '',
        '[contractSum]': amtStr(previewDetail?.contract?.contractSum),
        '[voAmount]': amtStr(previewDetail?.voDisplayAmt),
        '[revisedContractSum]': amtStr(
          previewDetail?.contract?.revisedContractSum,
        ),
        '[maxRetentionSum]': amtStr(previewDetail?.contract?.maxRetentionSum),

        // ───── DOCUMENT INFO ─────
        '[claimNo]': previewDetail?.claimNo ?? previewDetail?.claimDocNo ?? '',
        '[docNo]': previewDetail?.docNo ?? '',
        '[docRefNo]': previewDetail?.docRef ?? '',
        '[preparedBy]': previewDetail?.preparedBy ?? '',

        // ───── DATES ─────
        '[docDate]': dateFormat(previewDetail?.contract?.startDate),
        '[docDueDate]': dateFormat(previewDetail?.contract?.endDate),
        '[submittedDate]': dateFormat(previewDetail?.submittedDate),
        '[approvalDate]': dateFormat(previewDetail?.docDate),

        // ───── CLAIM COMPONENTS ─────
        '[currentApprovalAmt]': amtStr(previewDetail?.submittedCertifiedAmt),
        '[voClaimAmt]': amtStr(previewDetail?.currentVOClaimAmt),
        '[totalClaimApprovalAmt]': amtStr(totalClaimAmt.toString()),
        '[currentMosAmt]': amtStr(previewDetail?.submittedMosAmt),
        '[materialOnSiteAmt]': amtStr(previewDetail?.submittedMosAmt),
        '[previousMosAmt]': amtStr(previewDetail?.previousMosAmt),
        '[previousCertifiedAmt]': amtStr(previewDetail?.previousCertifiedAmt),
        '[previousVOClaimAmt]': amtStr(previewDetail?.previousVOClaimAmt),
        '[dayworksAmt]': amtStr(previewDetail?.currentDayWorkAmt),
        '[currentDeductionAmt]': amtStr(previewDetail?.currentDeductionAmt),
        '[advanceRecoupmentAmt]': amtStr(previewDetail?.advanceRecoupmentAmt),

        // ───── CURRENCY ─────
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[noteText]': previewDetail?.noteText ?? '',
      });
      break;
    }

    /* -------------------------------------------------
     * 9. CLAIM WORKDONE
     * -------------------------------------------------*/
    case 'claim-workdone': {
      // ─── TYPES ─────────────────────────────────────────────
      type WBSItem = {
        ID: string;
        wsID?: string;
        name: string;
        sequence?: number;
        claimWBS?: {
          awardedAmt: number;
          previousCertifiedAmt: number;
          submittedCertifiedAmt: number;
          currentCertifiedAmt: number;
          netSubmittedAmt: number;
          netCurrentAmt: number;
          sequence?: number;
        };
        claimVOWBS?: Array<{
          docNo: string;
          awardedAmt: number;
          previousVOClaimAmt: number;
          submittedVOClaimAmt: number;
          currentVOClaimAmt: number;
          netSubmittedVOAmt: number;
          netCurrentVOAmt: number;
        }>;
      };

      type GroupedItem = {
        name: string;
        sequence?: number;
        status?: string;
        claimWBS?: WBSItem['claimWBS'];
        claimVOWBS: WBSItem['claimVOWBS'];
      };

      // ─── GROUPING & SORTING ────────────────────────────────
      const groupedItems: Record<string, GroupedItem> = {};

      (previewDetail?.claimDetailRevenueWBS as WBSItem[])?.forEach(wbs => {
        const groupKey = wbs.wsID || wbs.ID;
        if (!groupKey) return;

        if (!groupedItems[groupKey]) {
          groupedItems[groupKey] = {
            name: wbs.name,
            sequence: wbs.sequence ?? wbs.claimWBS?.sequence ?? 0,
            status: previewDetail?.transactionStatus,
            claimWBS: undefined,
            claimVOWBS: [],
          };
        }

        if (wbs.claimWBS) {
          groupedItems[groupKey].claimWBS = wbs.claimWBS;
        }

        if (wbs.claimVOWBS?.length) {
          groupedItems[groupKey].claimVOWBS.push(...wbs.claimVOWBS);
        }
      });

      const sortedGroups = Object.values(groupedItems).sort(
        (a, b) => (a.sequence || 0) - (b.sequence || 0),
      );

      // ─── DISPLAY ITEMS & TOTALS ────────────────────────────
      const displayItems = [];
      const grandTotals = {
        awardedAmt: 0,
        previousAmt: 0,
        currentAmt: 0,
        netAmt: 0,
      };

      sortedGroups.forEach(group => {
        const groupItems = [];
        const groupSubtotal = {
          awardedAmt: 0,
          previousAmt: 0,
          currentAmt: 0,
          netAmt: 0,
        };

        if (group.claimWBS) {
          const wbsItem = {
            type: 'work',
            name: group.name,
            awardedAmt: group.claimWBS.awardedAmt || 0,
            previousAmt: group.claimWBS.previousCertifiedAmt || 0,
            currentAmt:
              (group.status === 'APPROVED'
                ? group.claimWBS.currentCertifiedAmt
                : group.claimWBS.submittedCertifiedAmt) || 0,
            netAmt:
              (group.status === 'APPROVED'
                ? group.claimWBS.netCurrentAmt
                : group.claimWBS.netSubmittedAmt) || 0,
          };
          groupItems.push(wbsItem);

          groupSubtotal.awardedAmt += wbsItem.awardedAmt;
          groupSubtotal.previousAmt += wbsItem.previousAmt;
          groupSubtotal.currentAmt += wbsItem.currentAmt;
          groupSubtotal.netAmt += wbsItem.netAmt;
        }

        group.claimVOWBS?.forEach(vo => {
          const voItem = {
            type: 'vo',
            name: vo.docNo || 'VO Item',
            awardedAmt: vo.awardedAmt || 0,
            previousAmt: vo.previousVOClaimAmt || 0,
            currentAmt:
              (group.status === 'APPROVED'
                ? vo.currentVOClaimAmt
                : vo.submittedVOClaimAmt) || 0,
            netAmt:
              (group.status === 'APPROVED'
                ? vo.netCurrentVOAmt
                : vo.netSubmittedVOAmt) || 0,
          };
          groupItems.push(voItem);

          groupSubtotal.awardedAmt += voItem.awardedAmt;
          groupSubtotal.previousAmt += voItem.previousAmt;
          groupSubtotal.currentAmt += voItem.currentAmt;
          groupSubtotal.netAmt += voItem.netAmt;
        });

        if (groupItems.length) {
          displayItems.push(...groupItems);
          displayItems.push({
            type: 'subtotal',
            name: 'Subtotal',
            ...groupSubtotal,
          });

          grandTotals.awardedAmt += groupSubtotal.awardedAmt;
          grandTotals.previousAmt += groupSubtotal.previousAmt;
          grandTotals.currentAmt += groupSubtotal.currentAmt;
          grandTotals.netAmt += groupSubtotal.netAmt;
        }
      });

      // ─── PARAM ASSIGN ──────────────────────────────────────
      Object.assign(paramVal, debtorDetails, {
        // ─── General Info ───
        '[remark]': previewDetail?.remark ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ─── Amounts ───
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',

        // ─── Currency ───
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',

        // ─── Work Items ───
        items: displayItems.map((item, i) => ({
          '[index]': i + 1,
          '[workItemDesc]': item.name,
          '[awardedAmt]': amtStr(item.awardedAmt),
          '[previousAmt]': amtStr(item.previousAmt),
          '[currentAmt]': amtStr(item.currentAmt),
          '[netAmt]': amtStr(item.netAmt),
          '[isVO]': item.type === 'vo',
          '[isSubtotal]': item.type === 'subtotal',
          '[subtotalAwardedAmt]':
            item.type === 'subtotal' ? amtStr(item.awardedAmt) : '',
          '[subtotalPreviousAmt]':
            item.type === 'subtotal' ? amtStr(item.previousAmt) : '',
          '[subtotalCurrentAmt]':
            item.type === 'subtotal' ? amtStr(item.currentAmt) : '',
          '[subtotalNetAmt]':
            item.type === 'subtotal' ? amtStr(item.netAmt) : '',
        })),

        // ─── Totals ───
        '[totalApprovalAmt]': amtStr(grandTotals.awardedAmt.toFixed(2)),
        '[totalPreviousAmt]': amtStr(grandTotals.previousAmt.toFixed(2)),
        '[totalCurrentAmt]': amtStr(grandTotals.currentAmt.toFixed(2)),
        '[totalNetAmt]': amtStr(grandTotals.netAmt.toFixed(2)),
        '[totalAmtInWords]': moneyFunction(grandTotals.netAmt),

        // ─── Contract & Dates ───
        '[docDate]': dateFormat(previewDetail?.contract?.startDate),
        '[docDueDate]': dateFormat(previewDetail?.contract?.endDate),
        '[contractSum]': amtStr(previewDetail?.contract?.contractSum),
        '[voAmount]': amtStr(previewDetail?.voDisplayAmt),
        '[revisedContractSum]': amtStr(
          previewDetail?.contract?.revisedContractSum,
        ),
        '[maxRetentionSum]': amtStr(previewDetail?.contract?.maxRetentionSum),
        '[contractNo]': previewDetail?.contract?.contractNo ?? '',
        '[claimNo]': previewDetail?.claimNo ?? previewDetail?.claimDocNo ?? '',
        '[docNo]': previewDetail?.docNo ?? '',
        '[submissionDate]': dateFormat(previewDetail?.submittedDate),
        '[approvalDate]': dateFormat(previewDetail?.docDate),
        '[docRefNo]': previewDetail?.docRef ?? '',
        '[noteText]': previewDetail?.noteText ?? '',
      });
      break;
    }
  }
};
